import { Tabs } from 'antd';
import React from 'react';
import ManageUsers from '../manageUsers/ManageUsers';
import ManageProducts from '../manageProducts/ManageProducts';
import ManageMultimedia from '../manageMultimedia/manageMultimedia';


const ManageTabs = () => {
  return (
    <Tabs centered defaultActiveKey="1">
      <Tabs.TabPane
        tab="Actualizar Usuarios"
        key="1"
        style={{ textAlign: 'center' }}
      >
        <ManageUsers />
      </Tabs.TabPane>
      <Tabs.TabPane
        tab="Actualizar Productos"
        key="2"
        style={{ textAlign: 'center' }}
      >
        <ManageProducts/>
      </Tabs.TabPane>
      <Tabs.TabPane tab="Multimedia" key="3" style={{ textAlign: 'center' }}>
        <ManageMultimedia/>
      </Tabs.TabPane>
    </Tabs>
  );
};

export default ManageTabs;
